import axiosActionsFactory from '../axiosHelpers';
import { UrlService } from '../../../services';

export const GET_TELEMATIC_CONNECTION_CREATION_ATTEMPT = axiosActionsFactory(
  'GET_TELEMATIC_CONNECTION_CREATION_ATTEMPT',
);

export const fetchTelematicConnectionCreationAttempt = (contextCompanyId, type) => ({
  type: GET_TELEMATIC_CONNECTION_CREATION_ATTEMPT.START,
  payload: {
    request: {
      url: UrlService.inboundTelematicConnectionCreationAttempt(),
      params: { contextCompanyId, type },
    },
  },
});
